module.exports = __webpack_public_path__ + "img/yanyun1.183b33d4.png";